/**
 * Files Store - unified access layer for files list
 * Keeps in-memory snapshot and exposes small API to decouple modules
 */

(function(window) {
  'use strict';

  const DEFAULT_LIMIT = 200;

  const FilesStore = {
    _files: [],
    _lightIndex: null,

    init(config = {}) {
      if (config.files) this._files = Array.isArray(config.files) ? config.files : [];
      if (config.lightIndex) this._lightIndex = config.lightIndex;
      return this;
    },

    setFiles(files) {
      this._files = Array.isArray(files) ? files : [];
      return this;
    },

    getFiles() {
      return this._files || [];
    },

    getSnapshot(limit = DEFAULT_LIMIT) {
      const files = this.getFiles();
      const safe = typeof limit === 'number' && limit > 0 ? limit : DEFAULT_LIMIT;
      return files.slice(0, safe);
    },

    setLightIndex(index) {
      this._lightIndex = index || null;
      return this;
    },

    getLightIndex() {
      return this._lightIndex;
    }
  };

  // Global export
  window.filesStore = FilesStore;

  // ES Module export for modern imports
  if (typeof window !== 'undefined') {
    window.filesStoreModule = FilesStore;
  }

})(window);

export const filesStore = window.filesStore || {};


